const getLanguage = (locale: string) => {
    switch (locale) {
        case 'en':
        default:
            return 'en-US';
        case 'nl':
            return 'nl-NL';
        case 'de':
            return 'de-DE';
    }
};
export default getLanguage;
